<template>
  <li class="serp__filter--checkbox q-px-0 q-d-flex q-align-items-center" v-for="filterData in filterDataValues"
      :key="filterData.label">
    <div class="q-list-group q-w-100">
      <label class="q-list-group-item q-py-1 q-px-2">
        <input
            class="serp__filter--checkbox-input q-form-check-input q-me-1" type="checkbox" :data-field="field"
            :value="filterData.label"
            @change="updateFilter(field, filterData.label)"
            :checked="filtersStore.filterIsChecked(field, filterData.label)">
        <span class="serp__filter--label q-mx-2">{{ filterData.label }}</span>
        <span class="serp__filter--count q-figure-caption">({{ filterData.count }})</span>
      </label>
    </div>
  </li>
</template>

<script setup lang="ts">
import {defineProps, defineEmits} from 'vue';
import {useFiltersStore} from "@/store/SerpPage/FiltersStore";

const filtersStore = useFiltersStore();
const emit = defineEmits(['closeDropdown']);

defineProps(['filterDataValues', 'field'])

function updateFilter(field: string, label: string) {
  filtersStore.updateFilter(field, label);
  emit('closeDropdown');
}
</script>

<style scoped>
.q-badge {
  margin-left: 20px
}

input {
  cursor: pointer;
}

.serp__filter--label, .serp__filter--count {
  vertical-align: sub;
}

.q-list-group-item {
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: var(--q-list-group-border-width) solid var(--q-list-group-border-color);
  cursor: pointer;
  border-radius: 0 !important;
  text-wrap: nowrap !important;
  font-size: 0.85em;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.q-list-group-item:hover {
  background-color: #f8f9fa !important;
  /*border-bottom: var(--q-list-group-border-width) solid var(--q-red);*/
}

.q-list-group-item:hover input.serp__filter--checkbox-input {
  /*background-color: #f8f9fa!important;*/
  border: var(--q-list-group-border-width) solid var(--q-red);
}

.q-form-check-input {
  width: 1.25em;
  height: 1.25em;
  transition: height 0.15s ease-in-out, width 0.15s ease-in-out, color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.q-form-check-input:focus {
  border: var(--q-border-width) solid var(--q-border-color);
}
.q-form-check-input:checked[type=checkbox] {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3e%3c/svg%3e")
}

.q-form-check-input:checked {
  background-color: var(--q-red);
  border-color: var(--q-red);
  width: 1.35em;
  height: 1.35em;
}
</style>